import request from '@/util/request'


export const resourcesLists = (data) => request.post('/api/resourcesLists', data);  //获取文件列表

export const resourcesDetail = (data) => request.post('/api/resourcesDetail', data); //获取文件详情